<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CContainer>
            <div class="text-center">
            <img src="../assets/img/done.jpg" style="max-width:100%" class="mt-5"/>
            <h1 class="text-success"> <strong>Payment Successfull</strong></h1>
            <h4 class="text-black">Your payment have been processed !</h4>
          
           
          
            <br />
            
        </div>
        </CContainer>
        <Footerlayout></Footerlayout>
    </div>
</template>



<script>
import Vue from "vue";
import VueMeta from 'vue-meta'

Vue.use(VueMeta)

// import { Carousel3d, Slide } from "vue-carousel-3d";
// import AnimatedNumber from "animated-number-vue";
// import backgroundUrl from "../assets/img/bg3.png";

// // import Translator from "vue-gtranslate";
// // import "vue-gtranslate/translator.css";

// Vue.use(require("vue-moment"));
// import VuejsDialog from "vuejs-dialog";
// import "vuejs-dialog/dist/vuejs-dialog.min.css";
import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

// import VueAgile from "vue-agile";
// Vue.use(VueAgile);

// // in component

// import AOS from "aos";
// import "aos/dist/aos.css";

// // Tell Vue to install the plugin.
// Vue.use(VuejsDialog);

// import VueCal from "vue-cal";
// import "vue-cal/dist/vuecal.css";

// import _ from "lodash";
// import $ from "jquery";


import MenuIcon from "vue-material-design-icons/Menu.vue";
new Vue({
el: "#navbar",

data() {
return {
view: {
  topOfPage: true,
},
};
},
beforeMount() {
window.addEventListener("scroll", this.handleScroll);
},
methods: {
handleScroll() {
if (window.pageYOffset > 400) {
  if (this.view.topOfPage) {
    this.view.topOfPage = false;
    el.setAttribute(
      "style",
      "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
    );
  }
} else {
  if (!this.view.topOfPage) this.view.topOfPage = true;
  el.setAttribute(
    "style",
    "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
  );
}
},
},
});

export default {
name: "Login",
metaInfo: {
title: 'About Us - Pickiddo is a platform for managing online tuition by offering on-demand tuition services to those who want to learn interactively from the best teachers anywhere in the world.',
meta: [
{ property: 'og:title', content: 'About Us - Pickiddo is a platform for managing online tuition by offering on-demand tuition services to those who want to learn interactively from the best teachers anywhere in the world.' }
],
link: [
  { rel: 'canonical', href: 'https://www.pickiddo.com/About' }
]
},
components: {
// Carousel3d,
// Slide,
// VueCal,
// MenuIcon,
// agile: VueAgile,
Mainlayout,
// AnimatedNumber,
// backgroundUrl,
Footerlayout,
},
data() {
return {
slides: 5,
schedule: [],
packages: [],
FilteredGrades: [],

SearchQuery: "",

popupclassdetail: false,

isShowPrimary: true,
primary: [],
PrimarySchool: true,
isShowPrim: false,

isShowSecondary: false,
secondary: [],
SecondarySchool: false,

ModalPopup: false,
photoURLs: "",
showUSD: true,
};
},
created() {
AOS.init();
},
mounted() {

},
async mounted() {
    this.SubmitData();
},
beforeDestroy() {
window.removeEventListener("scroll", this.onScroll);
},
computed: {
valuesTotal: {
get: function () {
  var t = 30876;
  console.log("test" + t);
  return t;
},
},
},
methods: {
toggle() {
this.showUSD = !this.showUSD;
},
onScroll() {
// Get the current scroll position
const currentScrollPosition =
  window.pageYOffset || document.documentElement.scrollTop;
// Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
if (currentScrollPosition < 0) {
  return;
}
// Here we determine whether we need to show or hide the navbar
this.showNavbar = currentScrollPosition < this.lastScrollPosition;
// Set the current scroll position as the last scroll position
this.lastScrollPosition = currentScrollPosition;
},
handleScroll() {
if (window.pageYOffset > 1000) {
  if (this.view.topOfPage) {
    this.view.topOfPage = false;
  } else {
    this.view.topOfPage = true;
  }
}
},
SubmitData()
    {
      const formData = new FormData();
    
        formData.append("userId", this.$route.query.userId);
        formData.append("id", this.$route.query.id);


        return this.$API
          .post(this.$UpdatePaidPrestige, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.successModal = true;
             // this.$dialog.alert(response.data).then(function () {});
            // window.open("https://www.pickiddo.com/Notify", "_self");
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
     },
},
};
</script>

    <style scoped>

@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
    
.c-header {
  /* background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83; */
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  border-bottom: 0;
  border-bottom: 0;
  /* color: #fff; */
}
.c-app{
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: 'Montserrat', sans-serif;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
    font-family: "Montserrat", sans-serif;
}
label
{
  font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
  font-family: 'Montserrat';
font-style: normal;
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}
body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}


input {
border-bottom: 2px solid #fff;
background: none;
border-top: none;
border-left: none;
border-right: none;
width: -webkit-fill-available;
 -webkit-text-fill-color: white !important;

}
input ::placeholder {
color: #e0e0e0;
}

::placeholder {
/* Chrome, Firefox, Opera, Safari 10.1+ */
color: #e0e0e0;
}
.custom-user-input {
/* Body/1/Semibold */

display: flex;
justify-content: center;
flex-flow: row nowrap;
}


.js-click:active{
background:#E8F4FF;
border-radius:20px;
border:1px solid #E8F4FF;
}

.js-click:focus{
background:#E8F4FF;
border-radius:20px;
border:1px solid #E8F4FF;
}
.ui.button.toggle{
background: #E8F4FF;
color: #007CEF;
border:none;
border:2px solid #ddd;
padding:5px;
}

.ui.button.toggle.active{
background:#39f;
color:#fff;
}
.modal-header {
border-color:transparent
}
.modal-footer {
border-color:transparent;
}

.custom-height-card-about {
height: 200px;
}
.dropdown-menu.show {
display: block;
background: #41b2ff;
}
 </style>